import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import {
    applicationDetailsReducer, ApplicationRequirementDetailsReducer,
    generalDetailsReducer, JambRequirementDetailsReducer,
    loginDetailsReducer, OLevelRequirementDetailsReducer,
    permissionDetailsReducer,
} from "./detailsReducer";

import storage from "redux-persist/lib/storage";
import {projectCode} from "../resources/constants";

const rootReducer = combineReducers({
    generalDetails: generalDetailsReducer,
    permissionData: permissionDetailsReducer,
    loginDetails: loginDetailsReducer,
    applicationDetails: applicationDetailsReducer,
    ApplicationRequirementDetails: ApplicationRequirementDetailsReducer,
    JambRequirementsDetails:JambRequirementDetailsReducer,
    OLevelRequirementsDetails: OLevelRequirementDetailsReducer
});

const persistConfig = {
    key: projectCode,
    storage,
};

export default persistReducer(persistConfig, rootReducer);
